import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-qa": "product-grouped-option-text" }
const _hoisted_2 = { class: "_px-1 _pt-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_field_label = _resolveComponent("field-label")
  const _component_option_field = _resolveComponent("option-field")

  return (_openBlock(), _createBlock(_component_option_field, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
    "display-name": $props.option.text,
    options: $options.getOptions($props.option),
    class: _normalizeClass(['gfu-field-select--primary', $props.fieldClass]),
    "show-placeholder": true,
    name: "model",
    "show-label": $props.showLabel,
    inline: $props.inline,
    small: $props.small,
    "no-option-capitalize": true,
    disabled: $props.disabled,
    onChange: $options.onChange,
    "data-qa": 'product-grouped-option-field:' + $props.option.text
  }, _createSlots({ _: 2 /* DYNAMIC */ }, [
    ($props.showLabel)
      ? {
          name: "label",
          fn: _withCtx(() => [
            _createVNode(_component_field_label, {
              class: _normalizeClass(["_mb-1", $props.labelClass]),
              "is-required": $options.isRequired
            }, {
              description: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.tooltipLabel) + " ", 1 /* TEXT */),
                _createVNode(_component_tooltip, null, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString($options.tooltipDescription), 1 /* TEXT */),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.setItemNames, (name) => {
                        return (_openBlock(), _createElementBlock("li", { key: name }, _toDisplayString(name), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, { name: "circle-info" })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString($props.option.text), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-required", "class"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "display-name", "options", "class", "show-label", "inline", "small", "disabled", "onChange", "data-qa"]))
}